var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("HKLHoverTooltip", {
    staticClass: "tooltip-outer",
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function () {
          return [
            !_vm.url
              ? _c("div", { staticClass: "empty" }, [
                  _vm._v("\n      " + _vm._s(_vm.content) + "\n    "),
                ])
              : _c("a", { attrs: { href: _vm.url, target: "_top" } }, [
                  _vm._v("\n      " + _vm._s(_vm.content) + "\n    "),
                ]),
          ]
        },
        proxy: true,
      },
      {
        key: "tips",
        fn: function () {
          return [
            !_vm.url
              ? _c("div", [
                  _vm._v(
                    "\n      " +
                      _vm._s(_vm.$t("hint.venderInfoHint")) +
                      "\n    "
                  ),
                ])
              : _vm._t("default"),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }